  Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  }

function calcDate(days,today,todayHours){

  if( !todayHours){
    var todayHours = new Date().getHours();
  }
  console.log('today 1: '+ today + '; todayHours: ' + todayHours);
  if(todayHours < 17){
  console.log('todayHours is before 17');
  }
  else{
  console.log('todayHours is after 17');
    today = today + 86400000;
  }
  console.log('today 2: '+ today);
  
 var startDate = new Date(today);
  
  var newDate = new Date(today);
  newDate = newDate.addDays(days);
  console.log('today: '+ today +'; days: ' + days + '; startDate: ' + startDate + '; newDate: ' + newDate);
  
  while (startDate <= newDate) {
    
        const dayOfWeek = startDate.getDay();
    
    if(dayOfWeek == 0 || dayOfWeek == 6){ //if(dayOfWeek == 0 || dayOfWeek == 5 || dayOfWeek == 6)
      newDate = newDate.addDays(1)
    }
    startDate = startDate.addDays(1);
    //console.log('looping');
    }
    
  
  var resultDate = new Date(newDate);
  
  resultDate = + resultDate.getDate() + ' de ' + months[resultDate.getMonth()];
  console.log('today: ' + today + '; resultDate: ' + resultDate);
  
  return resultDate;
}

function updateDeliveryFields(){
  $('.deliveryData.added').each(function(){
    
    var id = $(this).data('id');
console.log('looking for .deliveryDataField[data-id="' + id + '"]');
    if($('.deliveryDataField[data-id="' + id + '"]').length > 0){
      
      $('.deliveryDataField[data-id="' + id + '"]').val($(this).text());

      console.log('input value: ' + $('.deliveryDataField[data-id="' + id + '"]').val());
    }
  })
}


function updateDeliveryDate(){
   $('.deliveryData:not(.added)').each(function(){
     
     var elem = $(this);
    var max = elem.data('delivery-max');
     
    var today = new Date().getTime();
     
    var todayHours = new Date().getHours();
     
    var maxDate = calcDate(max,today,todayHours);

     $(this).find('.date-content').html(maxDate);
     $(this).addClass('added');
    //elem.html(string);
     
     //$('.deliveryField[data-product-id="'+ elem.data('product-id') +'"]').val(string);
   })
  updateDeliveryFields();
}


   /*
   $('.deliveryCartAttr').each(function(){
                      
     var elem = $(this);
    var max = elem.data('max');
    var today = new Date().getTime();

    var maxDate = calcDate(max,today);
    
    var attrName = 'data-label';
    console.log('attrName: ' + attrName);
    var string = elem.attr(attrName).replace('{max}',maxDate);
    
    elem.val(string);
     
     $('.deliveryField[data-product-id="'+ elem.data('product-id') +'"]').val(string);         
      })
  */
  
document.addEventListener("DOMContentLoaded", function() {
    const timerHolders = document.querySelectorAll(".timer-holder");

    timerHolders.forEach(timerHolder => {
        const dateStr = timerHolder.getAttribute("data-date");

        // Convert dd/mm/yyyy to yyyy-mm-dd (ISO format for correct parsing)
        const dateParts = dateStr.split("/");
        if (dateParts.length !== 3) {
            console.error("Invalid date format:", dateStr);
            return;
        }
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T00:00:00`; // Set time to midnight
        const targetDate = new Date(formattedDate);

        function updateTimer() {
            const now = new Date();
            const timeDifference = targetDate - now;

            if (timeDifference > 0) {
                const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

                timerHolder.querySelector(".days .number span").textContent = String(days).padStart(2, '0');
                timerHolder.querySelector(".hours .number span").textContent = String(hours).padStart(2, '0');
                timerHolder.querySelector(".minutes .number span").textContent = String(minutes).padStart(2, '0');
                timerHolder.querySelector(".seconds .number span").textContent = String(seconds).padStart(2, '0');
            } else {
                timerHolder.querySelector(".timer").textContent = "Expired";
            }
        }

        updateTimer(); // Initial call
        setInterval(updateTimer, 1000); // Update every second
    });
});


$(document).ready(function(){
  updateDeliveryDate();

    const targetNode = document.querySelector('.cart__items .js-contents');

if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList' || mutation.type === 'subtree') {
                console.log('The contents of .cart__items .js-contents have changed.');
                // Your custom logic here

              if($('.cart__items .js-contents .deliveryData:not(.added)').length > 0){
              updateDeliveryDate();
              }
            }
        }
    });

    observer.observe(targetNode, {
        childList: true, // Detect addition/removal of child nodes
    });
}
});